export default {
  'trust:title': 'Uitstekende kwaliteit',
  'trust:seals:pdj-title': 'Futter Tester.de',
  'trust:seals:klimaneutral-title': 'ClimatePartner',
  'trust:seals:trusted-shop-title': 'Trusted Shops',
  'trust:seals:trusted-shop-rating': '„ZEER GOED“',
  'trust:seals:trusted-shop-review': '4.89/5.00 bij meer dan 4.116 beoordelingen',
  'trust:seals:ethical-award': 'Ethical Award',
  'trust:button': 'Onze belofte',
  'trust:money-back-guarantee': '30 dagen geld-terug-garantie',
};
